export const AVAILABLE_COLORS = [
	'#b80000', '#ff5722', '#fccb00', '#008b02',
	'#004dcf', '#7b1fa2', '#f2f3f2', '#000000'
]

export const SELECTION_TOOL = 'selection'
export const BRUSH_TOOL = 'brush'
export const LINE_TOOL = 'line'
export const ARROW_TOOL = 'arrow'
export const RECT_TOOL = 'rect'

export const MINIMUM_SIZE = 1
export const SIZE_RANGE = 7

export const toolIcons: Record<string, string> = {
	[ SELECTION_TOOL ]: 'pointer',
	[ BRUSH_TOOL ]: 'brush',
	[ LINE_TOOL ]: 'line',
	[ ARROW_TOOL ]: 'arrow-outward',
	[ RECT_TOOL ]: 'square'
}
